import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-position-relative get-the-look__stylisation-container"
}
const _hoisted_2 = {
  class: "q-row mb-5 stylisation__collage--container q-position-relative",
  style: {"background-color":"#f2f2f2","min-height":"500px","max-width":"460px","margin":"auto"}
}

import {onMounted, ref, PropType} from 'vue'
import ComponentLoader from '@/components/ComponentLoader.vue'
import {Navigation, Pagination} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import {storeToRefs} from 'pinia'
import {useGetTheLookStore} from '@/store/getTheLookStore'
import CollagesComponent from "@/components/StylisationCollage/CollagesComponent.vue";
import CollagesInfoComponent from "@/components/StylisationCollage/CollagesInfoComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StylisationCollage',
  props: {
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  setup(__props) {




const modules = ref([Pagination, Navigation])

const getTheLookStore = useGetTheLookStore()

const {getTheLooks, getGetTheLookLoading, hasGetTheLooks} = storeToRefs(getTheLookStore)

onMounted(async () => {
  await getTheLookStore.fetchGetTheLooks()
})


return (_ctx: any,_cache: any) => {
  return (_unref(hasGetTheLooks))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ComponentLoader, { loading: _unref(getGetTheLookLoading) }, null, 8, ["loading"]),
        _createVNode(_unref(Swiper), {
          class: "swiper",
          navigation: true,
          modules: modules.value,
          "space-between": 30,
          "slides-per-view": 1,
          "centered-slides": false,
          pagination: { clickable: true }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTheLooks), (stylisationSet) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                class: "slide",
                key: stylisationSet.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(CollagesComponent, {
                      products: stylisationSet.products
                    }, null, 8, ["products"]),
                    _createVNode(CollagesInfoComponent, {
                      products: stylisationSet.products
                    }, null, 8, ["products"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules"])
      ]))
    : _createCommentVNode("", true)
}
}

})